import React from 'react';
import {
  useAuthControllerVerifyMutation,
  useVerificationControllerResendMutation,
  useVerificationControllerVerifyMutation,
  VerifyDto,
} from '@/store/services/MidleNestApi.service';
import { errorHandler } from '@/utils/error.handler';
import { ErrorArea, Form, Input, ReformSubmitHandler, Submit } from '@kodkafa/reform';
import { useTranslation } from 'react-i18next';
import { ActionButton } from '@/components';
import { useNavigate, useParams } from 'react-router-dom';
import { storageLocal } from '@/utils';

export function EmailVerifyView() {
  const { t } = useTranslation();
  const params = useParams<{ email: string }>();
  const navigate = useNavigate();
  const email = params?.email ? decodeURIComponent(atob(params?.email)) : null;
  const [verification] = useVerificationControllerVerifyMutation();
  const [resend] = useVerificationControllerResendMutation();
  const [verify] = useAuthControllerVerifyMutation();
  const handleSubmit: ReformSubmitHandler<VerifyDto> = async (data, setError) => {
    await verification(data)
      .unwrap()
      .then(async (payload) => {
        if (payload) {
          storageLocal.setItem('accessToken', payload.token);
          await verify()
            .unwrap()
            .then(() => {
              navigate('../');
            })
            .catch((error) => errorHandler(error, setError));
        }
      })
      .catch((error) => errorHandler(error, setError));
  };

  const handleResend = async ({ email }: { email: string }) => {
    console.log('handleVerify');
    await resend({ data: email });
  };

  return (
    <div>
      <Form onSubmit={handleSubmit} defaultValues={{ data: email }} className='flex'>
        <div>
          <Input
            name='data'
            label={email ? 'Email address' : 'Phone Number'}
            placeholder={email ? 'jon@doe.com' : '+44'}
            className='w-full'
          />
        </div>
        <div>
          <Input
            name='code'
            label={t('Verification code')}
            placeholder={t('ABCG')}
            className='w-full'
          />
          <Input name='type' value='verify' type='hidden' />
        </div>
        <p className='text-xs text-gray-700 text-center'>
          {t('Check your inbox for the validation code.')}
        </p>
        <ErrorArea />
        <div>
          <Submit>{t('Verify')}</Submit>
        </div>
      </Form>
      <ActionButton data-email={email} className='button sm' onClick={handleResend}>
        Re-send Verify <i className='icon-ok' />
      </ActionButton>
    </div>
  );
}
